module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#logic",
      toString: function () {
        return this.url;
      }
    }